// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var UtilsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function UtilsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Get server disk space
     *
     * @since 1.0.0
     *
     * @param
     */
    UtilsService.prototype.getServerDiskSpace = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "utils/disk-space")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    UtilsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: UtilsService, providedIn: "root" });
    return UtilsService;
}());
export { UtilsService };
